module.exports = __webpack_public_path__ + "img/yixun_20210901112746.17c46d8b.png";